import { c as _c } from "react/compiler-runtime";
import RequestResetPasswordView from "@repo/ui/components/auth/RequestResetPasswordView";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { authClient } from "@/clients/authClient";
import { requestResetPasswordSearchSchema } from "@/lib/schemas/searchParams.schema";
import { decodeStatusParam } from "@/lib/utils/statusParam";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_public/_auth/begar-aterstall-losenord")({
  component: RequestResetPasswordPage,
  validateSearch: requestResetPasswordSearchSchema
});
function RequestResetPasswordPage() {
  const $ = _c(15);
  const navigate = useNavigate();
  const search = Route.useSearch();
  const t0 = search.error || search.meddelande;
  let t1;
  if ($[0] !== t0) {
    t1 = decodeStatusParam(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const decoded = t1;
  let t2;
  if ($[2] !== decoded || $[3] !== search.error) {
    t2 = decoded ? {
      message: decoded,
      variant: search.error ? "error" : "confirmation"
    } : undefined;
    $[2] = decoded;
    $[3] = search.error;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const statusMessage = t2;
  let t3;
  let t4;
  if ($[5] !== navigate) {
    t3 = () => navigate({
      to: "/logga-in",
      search: {
        bekraftelsemeddelande: encodeURIComponent(btoa("Ett e-postmeddelande med instruktioner f\xF6r att \xE5terst\xE4lla ditt l\xF6senord har skickats."))
      }
    });
    t4 = () => navigate({
      to: "/logga-in"
    });
    $[5] = navigate;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  const t5 = statusMessage;
  let t6;
  if ($[8] !== navigate) {
    t6 = () => navigate({
      to: "/begar-aterstall-losenord"
    });
    $[8] = navigate;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
    t7 = /*#__PURE__*/_jsx(RequestResetPasswordView, {
      authClient: authClient,
      onSuccess: t3,
      onBackToSignIn: t4,
      statusMessage: t5,
      onStatusMessageAction: t6
    });
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}